import { render } from "./RoleModal.vue?vue&type=template&id=70de05c1&scoped=true"
import script from "./RoleModal.vue?vue&type=script&lang=js"
export * from "./RoleModal.vue?vue&type=script&lang=js"

import "./RoleModal.vue?vue&type=style&index=0&id=70de05c1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70de05c1"]])

export default __exports__